<template>
    <v-card>
        <v-snackbar v-model="snackbar" :color="servicesData.color" :timeout="servicesData.timeout" top right>
            {{servicesData.message}}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('budget_request')}} {{$t('edit')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="formResponse">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="8" md="3">
                        <v-autocomplete v-model="requestData.fromReportID" @change="fReportID"
                                        required
                                        dense
                                        outlined
                                        :items="reportListF"
                                        single-line
                                        :disabled="isAutocompleteDisabled"
                                        item-text="value"
                                        item-value="id">
                            <template v-slot:label>
                                <span>  {{ $t('report') }}</span>
                            </template>
                        </v-autocomplete>


                    </v-col>
                    <v-col cols="8" md="3">

                        <v-autocomplete v-model.number="requestData.fromSubSectionID"
                                        required
                                        dense
                                        outlined
                                        :items="subsectionListF"
                                        single-line
                                        :disabled="isAutocompleteDisabled"
                                        item-text="value"
                                        item-value="id">
                            <template v-slot:label>
                                <span>{{ $t('from') }} {{ $t('subSectionName') }}</span>
                            </template>
                        </v-autocomplete>

                    </v-col>

                    <v-col cols="8" md="3">
                        <v-autocomplete class="unchangeable-radio"
                                        v-model="requestData.toReportID"
                                        required
                                        dense
                                        outlined
                                        :items="reportListT"
                                        single-line
                                        disabled
                                        item-text="value"
                                        item-value="id">
                            <template v-slot:label>
                                <span> {{ $t('report') }}</span>
                            </template>
                        </v-autocomplete>


                    </v-col>
                    <v-col cols="8" md="3">

                        <v-autocomplete v-model.number="requestData.toSubSectionID"
                                        required
                                        dense
                                        outlined
                                        :items="subsectionListT"
                                        single-line
                                        disabled
                                        item-text="value"
                                        item-value="id">
                            <template v-slot:label>
                                <span>{{ $t('to') }} {{ $t('subSectionName') }}</span>
                            </template>
                        </v-autocomplete>

                    </v-col>
                </v-row>


                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field style=" padding-top: 1.2rem;"
                                      label="Amount"
                                      v-model.number="requestData.amount"
                                      dense
                                      outlined
                                      type="number" :disabled="true"
                                      required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" style=" padding-top: 0px;">
                        <div class="radio-group" style=" padding-left: 8rem; padding-top: 0px;">
                            <v-radio-group v-model="requestData.transferModeID" :mandatory="false">
                                <v-radio v-for="(status, index) in transferModeType"
                                         :key="status.value"
                                         :value="status.value"
                                         :style="{ color: radioColors[index] }"
                                         class="custom-radio unchangeable-radio"
                                         disabled>
                                    <template v-slot:label>
                                        <span :style="{ color: radioColors[index] }">{{ status.id }}</span>
                                    </template>
                                </v-radio>
                            </v-radio-group>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea label="Remarks"
                                    v-model="requestData.remarks"
                                    dense
                                    outlined
                                    class="custom-textarea"></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea label="Reply"
                                    v-model="requestData.reply"
                                    dense
                                    outlined
                                    class="custom-textarea"></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-bind:label="$t('approved_by')"
                                      v-model="requestData.approvedBy"
                                      dense
                                      outlined
                                      class="custom-textarea"></v-text-field>
                    </v-col>
                </v-row>


            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">{{$t('reject')}}</v-btn>
            <v-btn class="custom-save-button" @click="submit">{{$t('approve')}}</v-btn>
            <!--<v-btn class="custom-save-button" @click="checksnackbar">{{$t('approve')}}</v-btn>-->
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "createUserForm",
        props: ['editItemIndex'],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            isBranch() {
                return this.userRole === "Branch"
            },
            userFirstNameErrors() {
                const errors = [];
                if (!this.$v.userData.firstName.$dirty) return errors;
                !this.$v.userData.firstName.required &&
                errors.push("First name is required.");
                return errors;
            },
            userLastNameErrors() {
                const errors = [];
                if (!this.$v.userData.lastName.$dirty) return errors;
                !this.$v.userData.lastName.required &&
                errors.push("Last name is required.");
                return errors;
            },
            userCompanyErrors() {
                const errors = [];
                if (!this.$v.userData.companyID.$dirty) return errors;
                !this.$v.userData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            userAddressErrors() {
                const errors = [];
                if (!this.$v.userData.address.$dirty) return errors;
                !this.$v.userData.address.required &&
                errors.push("User Address is required");
                return errors;
            },
            isAutocompleteDisabled() {
                return this.requestData.transferModeID !== 2;
            },
            userEmailErrors() {
                const errors = [];
                if (!this.$v.userData.email.$dirty) return errors;
                !this.$v.userData.email.required &&
                errors.push("User Email is required.");
                return errors;
            },
            userNameErrors() {
                const errors = [];
                if (!this.$v.userData.userName.$dirty) return errors;
                !this.$v.userData.userName.required &&
                errors.push("User name is required.");
                return errors;
            },
        },
        data() {
            return {
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                created: false,
                userData: {},
                requestData: {},
                confirmPassword: null,
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                companyList : [

                ],
                departmentList : [

                ],
                transferModeType: [{ id: "रकमान्तर", value: 1 },
                                   { id: "थप बजेट", value: 2 }],
                branchList : [

                ],
                designationList : [
                    { id: 1, value: 'Manager' },
                    { id: 2, value: 'Coordinator' }
                ],
                snackbar: false,
                servicesData: {
                    data: {},
                    message: "",
                    color: "",
                    timeout: 3000
                },
                subsectionListF:[],
                subsectionListT: [],
                reportListT: [],
                reportListF: []

            };
        },
        mounted() {
            this.getData()
        },
        methods: {

            
            dialogueClose() {
                this.requestData.statusID = 2
                    axios.post("ReportSettings/OfficeBudgetRequestUpdateDataAsync", this.requestData).then(response => {
                        if (response.data.success) {
                            this.snackbar.servicesData.data = response.data
                            this.snackbar.servicesData.message = "Budget Request Revised"
                            this.snackbar.servicesData.color = "success"
                            this.formResponse()
                        }
                    }).catch(response => {
                        this.snackbar.servicesData.data = response.data
                        this.snackbar.servicesData.message = "Error Budget Request, Please Contact Admin"
                        this.snackbar.servicesData.color = "error"
                        this.formResponse()
                    });
                this.$emit("dialogueClose");
            },
            formResponse() {
                this.$emit("dialogueClose");
            },
            submit() {
                this.requestData.statusID = 3
                    axios.post("ReportSettings/OfficeBudgetRequestUpdateDataAsync", this.requestData).then(response => {
                        console.log("getting", response)
                        if(response.data.success) {
                            this.snackbar = true;
                            this.servicesData.data = response.data
                            this.servicesData.message = response.data.message
                            this.servicesData.color = "success"
                            this.formResponse()
                        }
                        else {
                            this.snackbar = true;
                            this.servicesData.message = response.data.message
                        this.servicesData.color = 'error'
                        }

                    }).catch(response=>{
                        this.snackbar.servicesData.data=response.data
                        this.snackbar.servicesData.message ="Error Budget Request, Please Contact Admin"
                        this.snackbar.servicesData.color="error"
                        this.formResponse()
                    });
            },
            getData() {
                axios.get('ReportSettings/GetOfficeRequestBudgetByIDAsync?ID=' + this.editItemIndex).then(response => {
                    this.requestData = response.data
                })
                axios.get('ReportSettings/GetCurrentBudgetSubsectionListByIDAsync?ID=' + this.editItemIndex).then(response => {
                    this.reportListF = response.data.fromReportList
                    this.reportListT = response.data.toReportList
                    this.subsectionListF = response.data.fromSubSectionList
                    this.subsectionListT = response.data.toSubSectionList
                })

            },
            checksnackbar() {
                this.snackbar = true;
                this.servicesData.color = 'error';
                this.servicesData.message = 'Snackbar message';
            },
            fReportID(newValue) {
                let param = {
                    ID: this.editItemIndex,
                    ReportID: parseInt(newValue)

                }
                axios.get('ReportSettings/GetHeadOfficeBudgetSubsectionListByReportIDAsync', { params: param }).then(response => {
                    this.subsectionListF = response.data
                })
            },
            clear() {
                this.$v.$reset();
                this.userData = {};
            },
            
        }
    };
</script>


<style lang="scss" scoped>
    .employee-form-header {
        text-align: center;
        background-color: $main-color;
        height: 3em;
        padding: .6em;
        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }
    .unchangeable-radio {
        pointer-events: none; /* Prevent interaction */
        opacity: 1; /* Make it fully visible */
        /* Add any other styling you want here */
    }
</style>
